<div class="pt-4 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage this inbox.</h2>
</div>

<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4">
  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Invalid Documents
        <span *ngIf="activeInvalidDocuments">({{ activeInvalidDocuments.length }})</span>
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Completion Date</th>
        <th scope="col">Customer Name</th>
        <th scope="col">Document Name</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingActiveInvalidDocuments && activeInvalidDocumentsPresent()">
      <tr *ngFor="let invalidDocument of activeInvalidDocuments">
        <td>
          {{ timeStringFromISO8601(invalidDocument.document_completed_at) }},
          {{ dateStringFromISO8601(invalidDocument.document_completed_at) }}
        </td>
        <td>
          <ng-container *ngFor="let relatedCustomer of invalidDocument.related_customers; let last = last;">
            <a [routerLink]="['/customers', relatedCustomer.id.toString()]" target="_blank">
              {{ relatedCustomer.first_name }} {{ relatedCustomer.last_name }}
            </a>
            <br *ngIf="!last">
          </ng-container>
        </td>
        <td>{{ invalidDocument.document_name }}</td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openReviewActiveInvalidDocumentModal(invalidDocument);$event.preventDefault();">
            Review
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingActiveInvalidDocuments || !activeInvalidDocumentsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingActiveInvalidDocuments">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingActiveInvalidDocuments && !activeInvalidDocumentsPresent()">
          No outstanding invalid documents.
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>

<div class="pt-4 pl-md-4 mb-6">
  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Recently-Dismissed Invalid Documents
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Dismissed Date</th>
        <th scope="col">Customer Name</th>
        <th scope="col">Document Name</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingDismissedInvalidDocuments && dismissedInvalidDocumentsPresent()">
      <tr *ngFor="let invalidDocument of dismissedInvalidDocuments">
        <td>
          {{ timeStringFromISO8601(invalidDocument.dismissed_at) }},
          {{ dateStringFromISO8601(invalidDocument.dismissed_at) }}
        </td>
        <td>
          <ng-container *ngFor="let relatedCustomer of invalidDocument.related_customers; let last = last;">
            <a [routerLink]="['/customers', relatedCustomer.id.toString()]" target="_blank">
              {{ relatedCustomer.first_name }} {{ relatedCustomer.last_name }}
            </a>
            <br *ngIf="!last">
          </ng-container>
        </td>
        <td>{{ invalidDocument.document_name }}</td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openViewDismissedInvalidDocumentModal(invalidDocument);$event.preventDefault();">
            View
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingDismissedInvalidDocuments || !dismissedInvalidDocumentsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingDismissedInvalidDocuments">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingDismissedInvalidDocuments && !dismissedInvalidDocumentsPresent()">
          No dismissed invalid documents.
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
